import React, { Component, PureComponent, Fragment } from 'react'

export default function ApproveFooter(props) {
  let {
    group,
    groupId,
    validationError,
    nextGroup,
    changeGroup,
    approves,
    onApproveChange,
    canSubmit,
    submitting,
    handleSubmit,
    submitted,
    notfound,
    t,
  } = props

  let approved = approves.get(groupId)

  if (submitted || notfound) return null

  return (
    <div className="approve-footer">
      <div className="approve-footer-container">
        {groupId === 'final' ? (
          <div className="approve-footer-action-inner">
            <div className="approve-footer-action-center">
              {submitting ? (
                <button
                  className="approve-footer-action-button approve-footer-action-button--submit"
                  onClick={e => e.preventDefault()}>
                  <i className="fa fa-spin fa-spinner" />
                  {t('approve.action.submitting')}
                </button>
              ) : canSubmit ? (
                <button
                  className="approve-footer-action-button approve-footer-action-button--submit"
                  onClick={e => e.preventDefault() & handleSubmit()}>
                  <i className="fa fa-save" />
                  {t('approve.action.submit')}
                </button>
              ) : null}
            </div>
          </div>
        ) : !groupId ? (
          <div className="approve-footer-action-inner">
            <div className="approve-footer-action-center">
              <button
                className="approve-footer-action-button approve-footer-action-button--start"
                onClick={e => e.preventDefault() & changeGroup(nextGroup)}>
                <i className="fa fa-chevron-right" />
                {t('approve.action.start')}
              </button>
            </div>
          </div>
        ) : approved === true ? (
          <div className="approve-footer-action-inner">
            <div className="approve-footer-action-left">
              <button
                className="approve-footer-action-button approve-footer-action-button--cancel"
                onClick={e => e.preventDefault() & onApproveChange(groupId, undefined)}>
                {t('approve.action.cancel')}
              </button>
            </div>
            <div className="approve-footer-action-center">
              <div></div>
            </div>
            <div className="approve-footer-action-middle">
              {nextGroup ? (
                <button
                  className="approve-footer-action-button approve-footer-action-button--next"
                  id="action-next"
                  onClick={e => e.preventDefault() & changeGroup(nextGroup)}>
                  {t('approve.action.next')}
                  <i className="fa fa-chevron-right" />
                </button>
              ) : null}
            </div>
          </div>
        ) : approved === false ? (
          <div className="approve-footer-action-inner">
            <div className="approve-footer-action-left">
              <button
                className="approve-footer-action-button approve-footer-action-button--cancel"
                onClick={e => e.preventDefault() & onApproveChange(groupId, undefined)}>
                {t('approve.action.cancel')}
              </button>
            </div>
            <div className="approve-footer-action-center">
              <div></div>
            </div>
            <div className="approve-footer-action-middle">
              {nextGroup ? (
                <button
                  className={`approve-footer-action-button approve-footer-action-button--${
                    !validationError ? 'next' : 'next-error'
                  }`}
                  onClick={e => e.preventDefault() & changeGroup(nextGroup, groupId)}>
                  {t('approve.action.next')}
                  <i className="fa fa-chevron-right" />
                </button>
              ) : null}
            </div>
          </div>
        ) : (
          <div className="approve-footer-action-inner">
            <div className="approve-footer-action-center">
              <button
                className="approve-footer-action-button approve-footer-action-button--yes"
                onClick={e => e.preventDefault() & onApproveChange(groupId, true)}>
                <i className="fa fa-check" />
                {t('approve.action.yes')}
              </button>
              <button
                className="approve-footer-action-button approve-footer-action-button--no"
                onClick={e => e.preventDefault() & onApproveChange(groupId, false)}>
                {t('approve.action.no')}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
